// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"259":"paywall-settings","357":"viewsVods","665":"viewsSimulcasts","824":"viewsLivestreams"}[chunkId] || chunkId) + "." + {"170":"a64389b3","259":"1e7c107f","353":"5611766e","357":"9ae42f40","637":"520785ef","656":"9d199db5","665":"93a4919a","824":"d80884c2","927":"90c0f9d7"}[chunkId] + ".js";
};